
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's30de7aea55ecfb39': `Services pas inclus`,
's32a717533f0302f7': `Remarques`,
's8d230f0ca645537a': `Informations sur le navire`,
'sb72575e21bba70be': `Hébergements`,
'sbe0534087efc475b': `Services inclus`,
'sc178ecd678298a49': `Bon à savoir`,
    };
  